import type { YouTubeSearchResult } from '@/types';

const API_KEY = import.meta.env.VITE_YOUTUBE_API_KEY;
const API_URL = 'https://www.googleapis.com/youtube/v3';

export class YouTubeService {
    static async searchVideos(query: string): Promise<YouTubeSearchResult[]> {
        if (!query.trim()) return [];

        if (!API_KEY) {
            console.warn('YouTube API Key is missing. Using mock data.');
            return this.getMockResults(query);
        }

        try {
            const response = await fetch(
                `${API_URL}/search?part=snippet&type=video&maxResults=10&q=${encodeURIComponent(query)}&key=${API_KEY}`
            );

            if (!response.ok) {
                throw new Error('Failed to fetch from YouTube API');
            }

            const data = await response.json();

            return data.items.map((item: any) => ({
                videoId: item.id.videoId,
                title: item.snippet.title,
                channelTitle: item.snippet.channelTitle,
                thumbnail: item.snippet.thumbnails.default.url, // default or high
                duration: 0, // API search endpoint doesn't return duration. Set 0.
                publishedAt: item.snippet.publishedAt
            }));
        } catch (error) {
            console.error('YouTube search error:', error);
            return [];
        }
    }

    // Fallback for development if no key provided
    private static getMockResults(query: string): YouTubeSearchResult[] {
        return [
            {
                videoId: 'dQw4w9WgXcQ',
                title: `Mock Result 1 for "${query}"`,
                channelTitle: 'Rick Astley',
                thumbnail: 'https://i.ytimg.com/vi/dQw4w9WgXcQ/default.jpg',
                duration: 212,
                publishedAt: new Date().toISOString()
            },
            {
                videoId: 'jfKfPfyJRdk',
                title: 'Lofi Hip Hop Radio',
                channelTitle: 'Lofi Girl',
                thumbnail: 'https://i.ytimg.com/vi/jfKfPfyJRdk/default.jpg',
                duration: 0,
                publishedAt: new Date().toISOString()
            },
            {
                videoId: '5qap5aO4i9A',
                title: 'Lofi Hip Hop Radio - Beats to Relax/Study to',
                channelTitle: 'ChilledCow',
                thumbnail: 'https://i.ytimg.com/vi/5qap5aO4i9A/default.jpg',
                duration: 0,
                publishedAt: new Date().toISOString()
            }
        ];
    }
}
